<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Manage Shopping Banner</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="row d-flex  align-items-center flex-wrap grid-margin">
            <div class="col-md-4">
                <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="clearFilter()"></app-button>

                <button type="button" class="btn btn-primary text-nowrap" (click)="goToManagePromotionForm(0)">
                    <i class="fa fa-plus"></i> Add
                </button>
            </div>

            <div class="col-md-5 padd-right-file" style="display: flex;">
                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                    style="margin-bottom: 1rem !important;">
                    <mat-label>Search</mat-label>
                    <div class="search-input-container">
                        <input placeholder="Enter Customer Number / Application / Name / Contact Number" id="search"
                            matInput (keydown.enter)="getTableData(filterValue)" (keyup)="applyFilter($event)"
                            type="text" #searchInput>
                    </div>
                </mat-form-field>
                <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                    (click)="getTableData(filterValue)">
                    <mat-icon style="color: white;">search</mat-icon>
                </button>
            </div>

          
        </div>

        <div class="table-responsive mt-2 mb-4">
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                <ng-container matColumnDef="promotion">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="promotion">Promotion</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promotionName}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="price">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="price">Price</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.promoPrice===null?'-':dataField.promoPrice}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="product_name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="product_name">Product Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.productName===null?'-':dataField.productName}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="sub_category_name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="sub_category_name">Sub Category
                        Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.subCategoryName}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="start_date">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="start_name">Start Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.startOnTs | date: 'mediumDate'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="expiry_date">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="expiry_date">Expiry Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.expiredOnTs===null?'-':dataField.expiredOnTs |
                            date: 'mediumDate'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="action">Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <div class="text-truncate text-center">
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3"
                                (click)="goToManagePromotionForm(dataField.promotionId)"></i>
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash-can"
                                (click)="delete(dataField.promotionId)"></i>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="data.length===0" class="text-center">
            No Results Found
          </div>

        <div class="table_pagenation">
            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>
